import React from "react";

import { AnnotationEditor, useAnnotationStore } from "@perceptron/core";

import { useMediaStore } from "@demo/store/media";

export interface ConnectedAnnotationEditorProps {
  mediaSetId: string;
  currentImageIndex: number;
  onNavigate: (index: number) => void;
}

/**
 * ConnectedAnnotationEditor - Wrapper that connects AnnotationEditor to stores
 *
 * This component:
 * - Subscribes to media store to get media data
 * - Provides setActiveMedia callback from annotation store
 * - Passes all data to the pure AnnotationEditor component
 */
export function ConnectedAnnotationEditor({
  mediaSetId,
  currentImageIndex,
  onNavigate,
}: ConnectedAnnotationEditorProps) {
  // Get the media set from the mediaStore
  const mediaSet = useMediaStore((state) => state.mediaSets.find((set) => set.id === mediaSetId));
  const setActiveMedia = useAnnotationStore((state) => state.setActiveMedia);

  // Extract media or provide empty array
  const media = mediaSet?.media || [];

  return (
    <AnnotationEditor
      currentIndex={currentImageIndex}
      media={media}
      mediaSetId={mediaSetId}
      onActiveMediaChange={setActiveMedia}
      onNavigate={onNavigate}
    />
  );
}

export default ConnectedAnnotationEditor;
